<template>
  <div class="wrapper-template notFoundWrapper" id='sectionContainer'>
    <div class="wrapper-template__inner not-found-wrapper-inner height-100">
      <img class="moon-img" src="../../public/assets/images/404/moon.png" alt="">
      <!-- <img class="wolf-img" src="../../public/assets/images/404/wolf.png" alt=""> -->
      <div class="wolf-img"></div>
      
      <div class="pnf-number"><span>404</span></div>
      <div class="pnf-wrapper">

        <div class="pnf-wrapper__text">
          <div class="pnf-wrapper__text-title" v-html="lang.title"></div>
          <div>
            <span class="pnf-wrapper__text-sorry" v-html="lang.smallText"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="btn-next-wrapper">
      <a class="wrapper-link-btn" :href="baseUrl + 'index.html'">
        <div class="button-slider button-slider_position-bottom-right">
          <img class="to-right-icon" src="../../public/assets/images/arrow_icon_white.png" alt="">
        </div>
      </a>
    </div>

    <div class="text-next-wrapper">
      <div class="next-btn-info-text next-btn-info-text_position-bottom-right">{{lang.btnText}}</div>
    </div>

  </div>
</template>

<script>
import switchClasses from '@/util/switcherClasses.js'
const baseUrl = process.env.BASE_URL

export default {
  name: 'NotFoundPage',

  data() {
    return {
      baseUrl: baseUrl,
      lang: this.$root.$options.LANG.PAGE_NOT_FOUND,
    }
  },

  mounted: function() {
    switchClasses({add: 'show',remove: 'hide'}, 'sectionContainer');
    this.$emit('isNotFound', [{is: true}]);
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrapper-template__inner {
  padding-bottom: 0 !important;
}
</style>
